import Vue from 'vue';
import moment from 'moment';

/**
 * Vue filter to round the decimal to the given place.
 * @param {String} value    The value string.
 * @param {Number} decimals The number of decimal places.
 */

Vue.filter('round', (value, decimals) => {
  if (value)
    value = parseFloat(value).toFixed(decimals);
  return value;
});

Vue.filter('doubleDigit', (value) => {
  if (value === 'G')
    return value;
  return parseInt(value, 10).toLocaleString(undefined, { minimumIntegerDigits: 2 });
});

Vue.filter('date', (date) => {
  if (date)
    return moment(date).format('DD-MM-YYYY');
  return date;
});

Vue.filter('activity_date', (date) => {
  if (date) {
    const dateObj = new Date(date);
    return `${dateObj.getFullYear()}-${dateObj.getMonth() + 1}-${dateObj.getDate()}, ${dateObj.getHours()}:${dateObj.getMinutes()}:${dateObj.getSeconds()}`;
  }
  return date;
});

Vue.filter('timestamp_date', (date) => {
  if (date) {
    const dateObj = new Date(date * 1000);
    return `${dateObj.getFullYear()}-${dateObj.getMonth() + 1}-${dateObj.getDate()}`;
  }
  return date;
});

Vue.filter('currencyFormatter', (value) => {
  if (value) {
    value = parseFloat(value);
    const modifiedVal = value.toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return modifiedVal;
  }
  return value;
});

Vue.filter('currencyFormatterNoDecimal', (value) => {
  if (value) {
    value = parseFloat(value);
    const modifiedVal = value.toLocaleString('en-IN', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
    return modifiedVal;
  }
  return value;
});

Vue.filter('notificationTime', (d) => {
  const now = moment(new Date());
  const months = now.diff(d, 'months');
  const days = now.diff(d, 'days');
  const hours = now.diff(d, 'hours');
  const minutes = now.diff(d, 'minutes');
  if (months > 0)
    return `${months}mon`;
  else if (days > 0)
    return `${days}d`;
  else if (hours > 0)
    return `${hours}hr`;
  return `${minutes}min`;
});



// WEBPACK FOOTER //
// ./src/filters/filters.js